<template>

  <div class="modal-mask" v-show="showUserAddModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <ValidationObserver ref="form">
          <div class="modal-header">
            <slot name="header">Пользователь</slot>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label>Имя</label>
              <ValidationProvider rules="required" v-slot="{ errors }" class="w-100">
                <input type="text" class="form-control" v-model="user.name" required/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>E-mail</label>
              <ValidationProvider rules="required|email" v-slot="{ errors }" class="w-100">
                <input type="email" class="form-control" v-model="user.email"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>дата окончания действительности</label>
              <input type="date" class="form-control" v-model="user.valid_till1"/>
            </div>
            <div class="form-group">
              <label>ПИНФЛ</label>
              <input type="text" class="form-control" v-model="user.pinfl"/>
            </div>
            <div class="form-group">
              <label> имя пользователя</label>
              <input type="text" class="form-control" v-model="user.first_name"/>
            </div>
            <div class="form-group">
              <label> фамилию пользователя</label>
              <input type="text" class="form-control" v-model="user.surname"/>
            </div>
            <div class="form-group">
              <label> отчество пользователя</label>
              <input type="text" class="form-control" v-model="user.patronymic"/>
            </div>
            <div class="form-group">
              <label> организацию пользователя</label>
              <input type="text" class="form-control" v-model="user.org_name"/>
            </div>
            <div class="form-group">
              <label> должность пользователя</label>
              <input type="text" class="form-control" v-model="user.level"/>
            </div>
            <div class="form-group">
              <label> телефон пользователя (pattern : +123(12)123-12-12)</label>
              <input type="text" @input="acceptNumber" class="form-control" v-model="user.phone"/>
            </div>

            <div class="form-group">
              <label> Роль </label>
              <select v-model="user.role_id" class="form-control">
                <option value="0">_</option>
                <option v-for="role in roles" :value="role.id">{{role.name}}</option>
              </select>
            </div>

            <div class="form-group">
              <label>Пароль</label>
              <ValidationProvider rules="required|min:4|confirmed:confirmation" v-slot="{ errors }" class="w-100">
                <input type="password" class="form-control" v-model="user.password"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <label>Повторите пароль</label>
              <ValidationProvider vid="confirmation" v-slot="{ errors }" class="w-100">
                <input type="password" class="form-control" v-model="confirmation"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button type="button" class="modal-button btn btn-danger" @click="updateModal({modal:'add',visible:false})">Закрыть
              </button>
              <button type="button" class="modal-button btn btn-warning" @click="userStore()">Добавить</button>
            </slot>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>

</template>

<script>
import {POST} from "@/shared/api";
import moment from "moment";

export default {
  props:{
    showUserAddModal: false,
    roles: [],
    user: {},
  },
  data(){
    return {
      confirmation: false
    }
  },
  methods:{
    acceptNumber(){
      let x = this.user.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/);
      this.user.phone = !x[2] ? x[1] : '+'+ x[1] +'(' + x[2] + ')' + x[3] + (x[4] ? '-' + x[4] : '') + (x[5] ? '-' + x[5] : '');
    },
    format(value, event) {
      return moment(value).format('YYYY-MM-DD')
    },
    updateModal(state, event = 'update'){
      this.$emit(event,state);
    },
    userStore() {
      this.user.valid_till = this.format(this.user.valid_till1)
      this.$refs.form.validate().then(success => {
        if (success) {
          POST(this.user, "/user", this, true).then(response => {
            this.updateModal({modal:"stored"})
          });
        }
      })
    },
  }
}
</script>

<style scoped>

</style>